var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              !_vm.showSpecificRecordDetails
                ? _c("div", { staticClass: "header-extra" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm widget-header-button m-r-5",
                        attrs: { "data-testid": "buyers-export-button" },
                        on: {
                          click: function($event) {
                            return _vm.exportToCSV()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("EXPORT_CSV")) +
                            "\n      "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filters.name.value,
                          expression: "filters.name.value"
                        }
                      ],
                      staticClass:
                        "form-control input-md widget-header-input m-r-10",
                      attrs: {
                        type: "search",
                        "data-testid": "buyers-search",
                        placeholder: _vm.$t("BUYERS_SEARCH_PH")
                      },
                      domProps: { value: _vm.filters.name.value },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.filters.name,
                            "value",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.isFetchingBuyers
        ? _c("div", { staticClass: "m-b-15 m-t-10" }, [
            _vm.hasCreateAccess && !_vm.showSpecificRecordDetails
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-success btn-sm",
                    attrs: {
                      type: "button",
                      "data-testid": "buyers-create-button",
                      disabled: _vm.formActive && !_vm.activeBuyer
                    },
                    on: {
                      click: function($event) {
                        return _vm.showForm(null, $event)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "BUYERS_ADD_BUTTON",
                          expression: "'BUYERS_ADD_BUTTON'"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showSpecificRecordDetails
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    on: { click: _vm.goToBuyers }
                  },
                  [
                    _c("i", { staticClass: "fa fa-arrow-left" }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "BUYER_SHOW_ALL",
                          expression: "'BUYER_SHOW_ALL'"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFetchingBuyers
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.getDisplayBuyers,
                    "current-page": _vm.currentPage,
                    "page-size": 20,
                    filters: _vm.filters,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              _vm.showAddNewForm && _vm.hasCreateAccess
                                ? _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "row-inline-new-form slide-down bg-row-even"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { attrs: { colspan: "100" } },
                                        [
                                          !_vm.showNewBuyerInvites
                                            ? _c("BuyerForm", {
                                                attrs: {
                                                  "show-loader":
                                                    _vm.isCreateBuyerLoading
                                                },
                                                on: {
                                                  cancel: _vm.hideForm,
                                                  submit:
                                                    _vm.handleAddBuyerSubmit
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showNewBuyerInvites &&
                                          _vm.invitesForBuyer
                                            ? _c("BuyerInvites", {
                                                attrs: {
                                                  "buyer-id":
                                                    _vm.invitesForBuyer.id,
                                                  "close-btn-text": _vm.isNewUserToNewBuyerInvited
                                                    ? "Close"
                                                    : "Skip"
                                                },
                                                on: {
                                                  close:
                                                    _vm.onNewBuyerInvitesClose,
                                                  "created-new-invite":
                                                    _vm.onAddingNewInviteToNewBuyer
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "title",
                                                      fn: function() {
                                                        return [
                                                          _c("p", [
                                                            _vm._v(
                                                              "\n                  Invite Users to\n                  "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .invitesForBuyer
                                                                    .name
                                                                )
                                                              )
                                                            ])
                                                          ])
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(buyer, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == buyer.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: buyer.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    attrs: {
                                                      disabled:
                                                        _vm.showCreateForm
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          buyer.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "companyName"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "companyName"
                                                      ].rowAlign,
                                                    "data-testid":
                                                      "company-name"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "clickable",
                                                      attrs: {
                                                        href: _vm.getBuyersEditHref(
                                                          buyer.id
                                                        )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showForm(
                                                            buyer,
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(buyer.name) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "subid"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "subid"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(buyer.subId) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "buyerCanPauseTargets"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "buyerCanPauseTargets"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("MiniToggle", {
                                                    attrs: {
                                                      "is-on":
                                                        buyer.canPauseTargets,
                                                      tooltip: _vm.$t(
                                                        buyer.canPauseTargets
                                                          ? "BUYER_CAN_PAUSE_TARGETS"
                                                          : "BUYER_CAN_NOT_PAUSE_TARGETS"
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleBuyerPermission(
                                                          {
                                                            buyer,
                                                            permissionProperty:
                                                              "canPauseTargets"
                                                          }
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "buyerCanSetTargetConcurrency"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "buyerCanSetTargetConcurrency"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("MiniToggle", {
                                                    attrs: {
                                                      "is-on":
                                                        buyer.canSetConcurrencyCaps,
                                                      tooltip: _vm.$t(
                                                        buyer.canSetConcurrencyCaps
                                                          ? "BUYER_CAN_SET_CONCURRENCY_CAPS_TARGETS"
                                                          : "BUYER_CAN_NOT_SET_CONCURRENCY_CAPS_TARGETS"
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleBuyerPermission(
                                                          {
                                                            buyer,
                                                            permissionProperty:
                                                              "canSetConcurrencyCaps"
                                                          }
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "buyerCanSetTargetConcurrency"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "buyerCanSetTargetConcurrency"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("MiniToggle", {
                                                    attrs: {
                                                      "is-on":
                                                        buyer.canDisputeConversions,
                                                      tooltip: _vm.$t(
                                                        buyer.canDisputeConversions
                                                          ? "BUYER_CAN_DISPUTE_CONVERSION"
                                                          : "BUYER_CAN_NOT_DISPUTE_CONVERSION"
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleBuyerPermission(
                                                          {
                                                            buyer,
                                                            permissionProperty:
                                                              "canDisputeConversions"
                                                          }
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "restrictDuplicate"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "restrictDuplicate"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName:
                                                            "v-tooltip.right.hover",
                                                          value: _vm.getPopoverText(
                                                            buyer.routeDuplicates
                                                          ),
                                                          expression:
                                                            "getPopoverText(buyer.routeDuplicates)",
                                                          modifiers: {
                                                            right: true,
                                                            hover: true
                                                          }
                                                        }
                                                      ],
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getRestrictionText(
                                                              buyer.routeDuplicates
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getRestrictionDurationText(
                                                              buyer.routeDuplicates
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            buyer.routeDuplicates &&
                                                              buyer
                                                                .routeDuplicates
                                                                .allowDuplicatesAfter !==
                                                                0 &&
                                                              buyer
                                                                .routeDuplicates
                                                                .previousCallState
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "currentHourSum"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "currentHourSum"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("LiveCounterCell", {
                                                    attrs: {
                                                      column: "currentHourSum",
                                                      "is-amount-type": true,
                                                      "usage-stats":
                                                        buyer.usageStats,
                                                      caps: buyer.caps
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "currentDaySum"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "currentDaySum"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("LiveCounterCell", {
                                                    attrs: {
                                                      column: "currentDaySum",
                                                      "is-amount-type": true,
                                                      "usage-stats":
                                                        buyer.usageStats,
                                                      caps: buyer.caps
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "currentMonthSum"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "currentMonthSum"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("LiveCounterCell", {
                                                    attrs: {
                                                      column: "currentMonthSum",
                                                      "is-amount-type": true,
                                                      "usage-stats":
                                                        buyer.usageStats,
                                                      caps: buyer.caps
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "totalSum"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "totalSum"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("LiveCounterCell", {
                                                    attrs: {
                                                      column: "totalSum",
                                                      "is-amount-type": true,
                                                      "usage-stats":
                                                        buyer.usageStats,
                                                      caps: buyer.caps
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "status"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "status"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("Status", {
                                                    attrs: { entity: buyer }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("BuyerActions", {
                                                    attrs: {
                                                      "create-access":
                                                        _vm.hasCreateAccess,
                                                      "current-buyer": buyer,
                                                      disabled: _vm.formActive,
                                                      "is-admin": _vm.isAdmin,
                                                      href: _vm.getBuyersEditHref(
                                                        buyer.id
                                                      )
                                                    },
                                                    on: {
                                                      "collapse-actions": function(
                                                        $event
                                                      ) {
                                                        !_vm.disabled &&
                                                          _vm.hideMobileAction()
                                                      },
                                                      "show-edit-form":
                                                        _vm.showForm,
                                                      "confirm-reset-cap-counters":
                                                        _vm.openConfirmResetCapCountersModal,
                                                      "confirm-delete":
                                                        _vm.openConfirmDeleteBuyerModal,
                                                      "show-invites":
                                                        _vm.showInvites,
                                                      "show-references":
                                                        _vm.showReferences
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  buyer.showInvites
                                    ? _c(
                                        "tr",
                                        {
                                          key: buyer.id + "-invites",
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("BuyerInvites", {
                                                attrs: { "buyer-id": buyer.id },
                                                on: {
                                                  close: function($event) {
                                                    return _vm.hideInvites(
                                                      buyer
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  buyer.showEditForm
                                    ? _c(
                                        "tr",
                                        {
                                          key: buyer.id + "-edit",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("BuyerForm", {
                                                attrs: {
                                                  "show-loader":
                                                    _vm.isUpdateBuyerLoading,
                                                  buyer: buyer
                                                },
                                                on: {
                                                  cancel: _vm.hideForm,
                                                  submit:
                                                    _vm.handleUpdaterBuyerSubmit
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  buyer.showReferences
                                    ? _c(
                                        "tr",
                                        {
                                          key: buyer.id + "-references",
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "p-15" },
                                                [
                                                  _c(
                                                    "legend",
                                                    {
                                                      staticClass:
                                                        "f-s-13 p-b-10"
                                                    },
                                                    [
                                                      _c("span", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value:
                                                              "BUYER_REFERENCES_TITLE",
                                                            expression:
                                                              "'BUYER_REFERENCES_TITLE'"
                                                          }
                                                        ]
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-xs btn-danger legend-right-button",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.hideReferences(
                                                                buyer
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "typcn typcn-delete"
                                                          }),
                                                          _vm._v(
                                                            "\n                    Close\n                  "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("BuyerReferences", {
                                                    attrs: {
                                                      "buyer-id": buyer.id
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == buyer.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: buyer.id + "-mobile",
                                          staticClass:
                                            "mobile-actions ng-animate-disabled slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("BuyerActions", {
                                                attrs: {
                                                  "create-access":
                                                    _vm.hasCreateAccess,
                                                  "current-buyer": buyer,
                                                  disabled: _vm.formActive,
                                                  "is-admin": _vm.isAdmin
                                                },
                                                on: {
                                                  "collapse-actions": function(
                                                    $event
                                                  ) {
                                                    !_vm.disabled &&
                                                      _vm.hideMobileAction()
                                                  },
                                                  "show-edit-form":
                                                    _vm.showForm,
                                                  "confirm-reset-cap-counters":
                                                    _vm.openConfirmResetCapCountersModal,
                                                  "confirm-delete":
                                                    _vm.openConfirmDeleteBuyerModal,
                                                  "show-invites":
                                                    _vm.showInvites,
                                                  "show-references":
                                                    _vm.showReferences
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }),
                              _vm._v(" "),
                              _c("tr", [
                                !_vm.showAddNewForm &&
                                (!_vm.getDisplayBuyers ||
                                  0 === _vm.getDisplayBuyers.length)
                                  ? _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "BUYERS_HEADER_NONE",
                                          expression: "'BUYERS_HEADER_NONE'"
                                        }
                                      ],
                                      attrs: { colspan: "100%" }
                                    })
                                  : _vm._e()
                              ])
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    2586235296
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.userVisibleColumns, function(col) {
                          return _c("v-th", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: _vm.columnSettings[col].displayName,
                                expression: "columnSettings[col].displayName"
                              }
                            ],
                            key: col,
                            class: _vm.columnSettings[col].class,
                            attrs: {
                              "default-sort":
                                _vm.columnSettings[col].defaultSort,
                              "sort-key": _vm.columnSettings[col].name
                            }
                          })
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "ACTIONS_COLUMN_HEADER",
                                  expression: "'ACTIONS_COLUMN_HEADER'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-7" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 20
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFetchingBuyers
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "BUYER_HEADER_LOADING",
                    expression: "'BUYER_HEADER_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteModal
        ? _c("BuyerDeleteModal", {
            attrs: {
              buyer: _vm.buyerForDelete,
              "loading-deleting-buyer": _vm.isBuyerDeleteLoading,
              "loading-buyer-references": _vm.isBuyerReferencesLoading,
              "buyer-references": _vm.buyerReferences,
              "check-references-text": _vm.checkReferencesText
            },
            on: { confirm: _vm.confirmDelete, close: _vm.closeDeleteModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showResetCapCounterModal
        ? _c("BuyerResetCapCountersModal", {
            attrs: {
              "current-buyer": _vm.currentBuyer,
              "is-buyer-reset-cap-counters-loading":
                _vm.isBuyerResetCapCountersLoading
            },
            on: {
              confirm: _vm.resetCapCounters,
              close: _vm.closeResetCapCounterModal
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }